import Icon from 'components/icon';
import { useState } from 'react';
import { setupInlineStyle } from 'utils/inlineConfig';

function Inline() : JSX.Element {
  const [showInline, setShowInline] = useState(false);

  const click = (className : string) : boolean => {
    const element = document.getElementsByClassName(className)[0];

    if(!element)
      return false;

    (element as HTMLElement).click();

    return true;
  };

  const onClick = () : void => {
    setupInlineStyle();

    if(showInline) {
      if(click('inmplayer-panel-close-button')) {
        setShowInline(false);
        return;
      }
    }

    click('biobar-inmplayer-trigger');
    setShowInline(true);
  };

  return (
    <a className="menu-help" onClick={onClick} >
      <Icon iconName='help' />
    </a>
  );
}

export default Inline;